import React from 'react';

import { IoIosArrowUp } from 'react-icons/io';
import smoothscroll from 'smoothscroll-polyfill';

import { ScrollTopButton } from '../styles/layOutStyles';

const ScrollTopBtn = ({ active }) => {
  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    smoothscroll.polyfill();
  };

  return (
    <ScrollTopButton onClick={scrollTop} active={active}>
      <IoIosArrowUp />
    </ScrollTopButton>
  );
};

export default ScrollTopBtn;
